{
  "id": "coal_camp",
  "w": 64,
  "h": 48,
  "navVersion": 3653730314,
  "walk": "DAEOBTMBAgAIAQIANwECAAQBAwC0AQEGAQUCBAEFAQMBBQEHAwUBBAEDMwEBAgYBAQMDAQEAAQMFAQEALQEBAwQBAQMGAQEDMwEBAgEBAQACAQECAQEBAwEBAwABAwsBAQcEBQEHBAUBAx0BAQYBBQIEAQUBAwEBAQcDBQEEAQMLAQEDAQADAQEDAgEBAAEBAQMdAQECBgEBAwMBAQABAwsBAQMBAAEBAQABAQEDBAEBAwYBAQAWAQEDBAEBAwYBAQMLAQEDBAEBAwQBAQMWAQEABgEBAgEBAQACAQEDAQEBAwEBAwABAwsBAQMJAQEDHQEBBgEFAgQBBQEDAQEBBwMFAQQBAwsBAQMEAQEDAgACAQEDHQEBAgYBAQMDAQEAAQMLAQEDBAEBAwQBAQMdAQEDBAEBAwYBAQMLAQEDBAEBAwQBAQMdAQECAQEBAAIBAQIBAQEDAQEDAAEDCwECBQEBBAUBAQIFHgEBBgEFAgQBBQEDAQEBBwMFAQQBAzMBAQIGAQEDAwEBAAEDBwEBACsBAQMEAQEDBgEBAzMBAQIBAQEAAgEBAwEBAQMBAQMAAQMgAQEAEgEFBQIBBQUqAQEACQEEAAQBAgA5AQEABgEBACgBCAABAQkAAgEUAAEBCwABAQsACgEBABMBAQATAQEAkQEDACUBAgCSAQgAAQEJAAIBFAABAQsAAQELAF0BAgA+AQIAAQECAAIBAgACAQIAAgECAAIBAgACAQIAAgECACYBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgAOAQEA1wECAAIBAgACAQIAAgECAAIBAgACAQIAAgECACEBAQAEAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAYwECAD4BAgBBAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAJgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAIYB",
  "objects": [
    {
      "oid": 1,
      "def": "svc.mama_put",
      "x": 16,
      "y": 23,
      "rot": 0
    },
    {
      "oid": 2,
      "def": "svc.bucket_bath",
      "x": 13,
      "y": 1,
      "rot": 0
    },
    {
      "oid": 3,
      "def": "svc.bucket_bath",
      "x": 14,
      "y": 1,
      "rot": 0
    },
    {
      "oid": 4,
      "def": "svc.ingredient_seller",
      "x": 32,
      "y": 34,
      "rot": 0
    },
    {
      "oid": 5,
      "def": "obj.generator",
      "x": 22,
      "y": 2,
      "rot": 0
    }
  ],
  "doors": [
    {
      "id": "door.no7.r1",
      "x": 18,
      "y": 6,
      "homeSlot": 1
    },
    {
      "id": "door.no7.r2",
      "x": 19,
      "y": 7,
      "homeSlot": 2
    },
    {
      "id": "door.no7.r3",
      "x": 18,
      "y": 10,
      "homeSlot": 3
    },
    {
      "id": "door.no7.r4",
      "x": 19,
      "y": 11,
      "homeSlot": 4
    },
    {
      "id": "door.no7.r5",
      "x": 18,
      "y": 14,
      "homeSlot": 5
    },
    {
      "id": "door.no7.r6",
      "x": 19,
      "y": 15,
      "homeSlot": 6
    }
  ],
  "stalls": [
    {
      "slot": 1,
      "x": 36,
      "y": 34,
      "queue": [
        {
          "x": 36,
          "y": 36
        },
        {
          "x": 36,
          "y": 37
        }
      ]
    },
    {
      "slot": 2,
      "x": 40,
      "y": 34,
      "queue": [
        {
          "x": 40,
          "y": 36
        },
        {
          "x": 40,
          "y": 37
        }
      ]
    },
    {
      "slot": 3,
      "x": 44,
      "y": 34,
      "queue": [
        {
          "x": 44,
          "y": 36
        },
        {
          "x": 44,
          "y": 37
        }
      ]
    },
    {
      "slot": 4,
      "x": 48,
      "y": 34,
      "queue": [
        {
          "x": 48,
          "y": 36
        },
        {
          "x": 48,
          "y": 37
        }
      ]
    }
  ],
  "pois": {
    "mama_put.npc": {
      "x": 17,
      "y": 22
    },
    "mama_put.use": {
      "x": 17,
      "y": 23
    },
    "bucket_bath.1.use": {
      "x": 13,
      "y": 2
    },
    "bucket_bath.2.use": {
      "x": 14,
      "y": 2
    },
    "ingredient_seller.npc": {
      "x": 33,
      "y": 33
    },
    "ingredient_seller.use": {
      "x": 32,
      "y": 36
    },
    "generator.use": {
      "x": 21,
      "y": 2
    },
    "no7.gate": {
      "x": 18,
      "y": 21
    },
    "akara.1.cook": {
      "x": 37,
      "y": 33
    },
    "akara.2.cook": {
      "x": 41,
      "y": 33
    },
    "akara.3.cook": {
      "x": 45,
      "y": 33
    },
    "akara.4.cook": {
      "x": 49,
      "y": 33
    }
  },
  "spawn": {
    "x": 19,
    "y": 12
  }
}
